// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__18trV","colMin":"styles_colMin__uLaKt","colCheckbox":"styles_colCheckbox__3l8iH"};